import React from 'react';
import PropTypes from 'prop-types';

function YesNoUnknown({ value }) {
  return (
    <span>
      {
        value === 2 &&
        'Possible'
      }
      {
        value === 1 &&
        'Yes'
      }
      {
        value === 0 &&
        'No'
      }
      {
        value === -1 &&
        'Unknown'
      }
    </span>
  );
}


YesNoUnknown.propTypes = {
  value: PropTypes.number,
};

YesNoUnknown.defaultProps = {
  value: -1,
};

export default YesNoUnknown;



// WEBPACK FOOTER //
// ./src/components/PropertyDetail/YesNoUnknown.js